import Container from '@mui/material/Container';
import { SchedulesView } from '../../features/schedules';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { PageHelmet } from '../../components';

const SchedulesPage = () => (
  <PageHelmet title={PAGES_ANALYTICS_TITLES.SCHEDULES}>
    <Container
      sx={{
        px: {
          xs: 0, lg: 2, md: 2, sm: 2,
        },
      }}
      maxWidth={false}
    >
      <SchedulesView />
    </Container>
  </PageHelmet>
);

export default SchedulesPage;
